/**
 * Contract Manager API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpResponse} from '@angular/common/http';

import {Observable} from 'rxjs';

import {MailItem} from '../model/mailItem';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class MailItemService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Retrieves the collection of all mail items
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMailItemCollection(observe?: 'body', reportProgress?: boolean): Observable<Array<MailItem>>;

  public getMailItemCollection(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MailItem>>>;

  public getMailItemCollection(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MailItem>>>;

  public getMailItemCollection(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<MailItem>>(`${this.basePath}/api/mail_items`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieve one mail item
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMailItemItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<MailItem>;

  public getMailItemItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MailItem>>;

  public getMailItemItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MailItem>>;

  public getMailItemItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getMailItemItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<MailItem>(`${this.basePath}/api/mail_items/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create new email object
   *
   * @param mailItem The new MailItem resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postMailItemCollection(mailItem?: MailItem, observe?: 'body', reportProgress?: boolean): Observable<MailItem>;

  public postMailItemCollection(mailItem?: MailItem, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MailItem>>;

  public postMailItemCollection(mailItem?: MailItem, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MailItem>>;

  public postMailItemCollection(mailItem?: MailItem, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<MailItem>(`${this.basePath}/api/mail_items`,
      mailItem,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
